import YoutubePlayer from './youtubeplayer';
import VideoPlayer from './videoplayer';
import lazyLoad from '../lazyload/lazyload'

class Player {
    constructor(_option){
        let extName = _option.videoId.substring(_option.videoId.lastIndexOf('.', _option.videoId.length)).toLowerCase();

        if(extName === '.mp4' || extName === '.webm') {
            this.player = new VideoPlayer(_option);
        } else {
            this.player = new YoutubePlayer(_option);
        }

        if(_option.autoPlay) {
            if(navigator.userAgent.match(/SamsungBrowser/)) {
                $(document).one(`click.player.autoPlay`, 'body', () =>{
                    console.log('body click');
                    this.play();
                });
            } else {
                $(document).one(`touchstart.player.autoPlay`, 'body', () =>{
                    this.play();
                });
            }
        }

        if(window.playerCss) {
            this.init();
        } else {
            window.playerCss = true;
            lazyLoad.css('https://wstatic.plaync.co.kr/promo/common/js/v2.0/player.css', () =>{
                this.init();
            });
        }
    }

    init(){
        this.player.init();
    }

    play(){
        this.player.play();
    }

    stop(){
        this.player.stop();
    }

    pause(){
        this.player.pause();
    }

    mute(){
        this.player.mute();
    }

    unMute(){
        this.player.unMute();
    }

    seek(t){
        this.player.seek(t);
    }
}

export default Player;